module.exports = __webpack_public_path__ + "img/images-regular.f0e2a448.svg";